import type Graph from 'graphology';
import type { PrecomputedLayoutDTO } from '../../utils/socialGraphApi';
import type { LayoutMode, LayoutWorkerRequest, LayoutWorkerResult } from './layoutPipeline';

export function buildLayoutRequest<N extends { community: number; size: number }, E extends { interCommunity: boolean }>(
  graph: Graph<N, E>,
  layoutMode: LayoutMode,
): LayoutWorkerRequest {
  const request: LayoutWorkerRequest = { nodes: [], edges: [], layoutMode };
  graph.forEachNode((id, attrs) => {
    request.nodes.push({ id, community: attrs.community, size: attrs.size });
  });
  graph.forEachEdge((_edge, attrs, source, target) => {
    request.edges.push({ source, target, interCommunity: attrs.interCommunity });
  });
  return request;
}

export function precomputedLayoutNodes(
  layout: PrecomputedLayoutDTO | null | undefined,
  layoutMode: LayoutMode,
  nodeIds: string[],
): LayoutWorkerResult['nodes'] | null {
  if (!layout || layout.mode !== layoutMode) return null;
  const nodes: LayoutWorkerResult['nodes'] = [];
  for (const id of nodeIds) {
    const position = layout.nodes[id];
    if (!position) return null;
    nodes.push({ id, x: position[0], y: position[1], isDust: position[2] });
  }
  return nodes;
}
